import { createFileRoute } from "@tanstack/react-router";
import { Users, Workflow, BarChart3 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import netImg from "@/assets/networking.jpg";

export const Route = createFileRoute("/vi/platform/crm")({
  head: () => ({
    meta: [
      { title: "CRM — banana.cards" },
      { name: "description", content: "CRM hiện đại, xây quanh cách bạn thực sự gặp gỡ. Liên hệ, pipeline, task và analytics thời gian thực." },
      { property: "og:title", content: "CRM — banana.cards" },
      { property: "og:description", content: "CRM hiện đại, xây quanh cách bạn thực sự gặp gỡ." },
      { property: "og:image", content: netImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/crm", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="CRM"
      title="CRM tự"
      italic="lấp đầy."
      description="Ghi lại mọi liên hệ ngay khi gặp, đẩy mọi deal tiến lên, và thấy chính xác điều gì hiệu quả — tất cả tại một nơi."
      heroImage={netImg}
      features={[
        { title: "Liên hệ", desc: "Mọi lead được ghi lại, làm giàu và khử trùng lặp tự động — từ quét, form, import và tích hợp.", href: "/vi/platform/contacts", icon: Users, bullets: ["Tự làm giàu", "Khử trùng lặp thông minh", "Tag, segment & list"] },
        { title: "Pipeline & Task", desc: "Pipeline tùy chỉnh, kéo thả deal, task tự gán và theo dõi SLA — chốt nhanh hơn.", href: "/vi/platform/pipelines", icon: Workflow, bullets: ["Pipeline không giới hạn", "Task với SLA", "Phân chia round-robin"] },
        { title: "Analytics", desc: "Dashboard thời gian thực qua thẻ, liên hệ, deal, hợp đồng và lịch hẹn — biết điều gì hiệu quả.", href: "/vi/platform/analytics", icon: BarChart3, bullets: ["Dữ liệu thời gian thực", "Cohort & funnel", "Báo cáo tùy chỉnh"] },
      ]}
      outro={{ title: "Ghi một lần.", italic: "Chốt nhiều hơn.", description: "CRM gặp bạn ngay nơi cuộc trò chuyện thực sự diễn ra." }}
    />
  );
}